// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BE-z","twoColumnImage":"CE-z"};